/* eslint-disable max-statements */
/* eslint-disable complexity */

import DatePickerMixin from '@/mixins/datepicker';
import DraftData from '@/components/draft-data';
import formatData from '@/mixins/formatData';
import keyed from '@/mixins/keyed';
import validations from '@/mixins/validations';
import FormWatcher from '@/inheritance/form-watcher';
import { sortByName } from '../../../utils/sort';

export default {
  name: 'AccountDetailsInfo',
  extends: FormWatcher,

  components: {
    DraftData
  },

  mixins: [DatePickerMixin, formatData, validations, keyed],

  watch: {
    autoFields: {
      handler() {
        Object.keys(this.autoFields).forEach(key => {
          this.formattedData[key] = this.autoFields[key];
        });
      },
      deep: true
    },
    datepickerFirstSubscription(val) {
      this.setValueEdited('first_subscription_date', val);
    },
    datepickerCreatedOn(val) {
      this.setValueEdited('created_on', val);
    },
    datepickerUpdatedOn(val) {
      this.setValueEdited('updated_on', val);
    }
  },

  /**
   * @override
   */
  data() {
    return {
      arrangementTypes: ['INDISTINTA', 'MANCOMUNADA'],
      mailingTypeOptions: ['POSTAL', 'EMAIL'],
      booleanOptions: ['YES', 'NO'],
      channelOptions: ['CORREO', 'MIGRACION', 'ONLINE', 'PRESENCIAL'],
      classOptions: ['A', 'B', 'C', 'D'],
      datepickerCreatedOn: '',
      datepickerFirstSubscription: '',
      datepickerUpdatedOn: '',
      distributors: {},
      distributorsOptions: [],
      subdistributors: [],
      subdistributorsOptions: [],
      detailsEdit: false,
      formatDataRules: () => ({
        is_withholding_tax_exempt: [value => (value ? 'YES' : 'NO')],
        is_transfers_blocked: [value => (value ? 'YES' : 'NO')]
      }),
      intervenerTypeOptions: ['F', 'J'],
      submiting: false,
      taxWithholdingOptions: ['ALAVA', 'GUIPUZCOA', 'NAVARRA', 'VIZCAYA', 'EXENTO', 'EXTRANJERO', 'GENERAL'],
      vissibilityCollapse1: true,
      formWatcherProperties: ['formattedData', 'modifiedData', 'detailsEdit'],
      investorClassOptions: ['MINORISTA', 'PROFESIONAL', 'NO_PROFESIONAL'],
      externalCodesTable: {
        fields: [
          { key: 'code', label: this.$t('headers.external_code') },
          { key: 'key_fund', label: this.$t('headers.key_product') }
        ],
        items: []
      },
      isLoading: false,
    };
  },
  props: {
    uuid: {
      type: String,
      required: false
    },
    creation: {
      type: Boolean,
      required: false
    },
    data: {
      type: Object,
      required: false
    },
    hideActions: {
      type: Boolean,
      required: false
    },
    autoFields: {
      type: Object,
      required: false
    }
  },
  methods: {
    /**
     * @param {Boolean} edit allow edit or not
     * @param {Event} e Evento del form
     */
    editDetails(edit, e) {
      e.preventDefault();
      e.stopPropagation();
      this.detailsEdit = edit;
      if (edit) {
        if (!this.vissibilityCollapse1) {
          this.$root.$emit('bv::toggle::collapse', 'collapse-1');
        }
      } else {
        this.modifiedData = {};
        this.formatData();
      }
    },

    /**
     * Guardar los datos
     * @param {Event} e FormEvent
     */
    onSubmit(e) {
      e.preventDefault();
      this.submiting = true;
      Object.keys(this.modifiedData).forEach(key => this.modifiedData[key] === '' && delete this.modifiedData[key]);

      const hasElementsModified = Object.keys(this.modifiedData).length;
      if (hasElementsModified  ) {
        this.$accountsService
          .updateAccountInfo(this.uuid, this.modifiedData )
          .then(res => {
            this.$toast.success(res.result.http_code, res.result.info);
            this.detailsEdit = false;
            this.submiting = false;
            this.modifiedData = {};
            this.$root.$emit('refresh_account');
          })
          .catch(err => {
            this.$toast.error(err.name, err.message);
            this.submiting = false;
          });
      } else {
        this.detailsEdit = false;
        this.submiting = false;
      }
    },

    /**
     * Función genérica para guardar los elementos editados
     * @param {*} field Campo editado
     * @param {*} val Valor
     * @param {Boolean} isDate Indica si el campo a editar es una fecha
     * @param {Boolean} isBoolean Indica si el campo a editar es un booleano
     */
    setValueEdited(field, val) {
      switch (field) {
        case 'distributor':
          if (val) {
            const tempDistributor = {};
            this.distributors.forEach(distributor => {
              if (distributor.key_name.toUpperCase() === val.toUpperCase()) {
                tempDistributor.id_object = distributor.id_object;
                tempDistributor.key_name = distributor.key_name;
                tempDistributor.refer_code = distributor.refer_code;
                tempDistributor.uuid = distributor.uuid_distributor;
              }
            });
            this.modifiedData[field] = tempDistributor;
          }
          break;
        case 'subdistributor':
          if (val) {
            const tempSubdist = {};
            this.subdistributors.forEach(sd => {
              if (sd.key_name.toUpperCase() === val.toUpperCase()) {
                tempSubdist.id_object = sd.id_object;
                tempSubdist.key_name = sd.key_name;
                tempSubdist.uuid = sd.uuid;
              }
            });
            this.modifiedData[field] = tempSubdist;
          }
          break;
        case 'account_type':
          this.modifiedData[field] = val;
          this.$emit('changeAccountType', val);
          break;
        case 'investor_class':
          this.modifiedData[field] = val;
          break;
        case 'is_transfers_blocked':
          this.modifiedData[field] = val === 'YES' ? true : false;
          break;
        case 'mailing_type':
          this.modifiedData[field] = val;
          break;
        default:
          this.modifiedData[field] = typeof val === Object ? val.key : val;
          break;
      }
    },
    
    distributorUpdate(val) {
      this.setValueEdited('distributor', val);
    },
    subdistributorUpdate(val) {
      this.setValueEdited('subdistributor', val);
    },
    getDistributors() {
      this.$distributorsService.getDistributors('', { params: { $limit: 9999 } }).then(res => {
        this.distributors = res.data.distributors;
        this.distributorsOptions = this.distributors.map(element => element.key_name).sort((a, b) => sortByName(a, b));
      })
    },
    getSubdistributors() {
      this.$subdistributorsService.getSubdistributors('', { params: { $limit: 9999 } }).then(res => {
        this.subdistributors = res.data.subdistributors;
        this.subdistributorsOptions = this.subdistributors.map(sd => sd.key_name).sort((a, b) => sortByName(a, b));
      });
    },
    /**
     * Obtenemos la cuenta
     * @param {String} uuid ID de la cuenta
     */
    async loadAccount() {
      this.isLoading = true;
      try {
        const params = {
          extCodesFromSM: this.allowExternalCodesFromSystemMappings 
        }
        
        const res = await this.$accountsService.getAccountsByUUId(this.uuid, { params })
        const externalCodesFromSM = res.data.account.external_code || [];
        if(this.allowExternalCodesFromSystemMappings) {
          this.externalCodesTable.items = externalCodesFromSM.map(ec => ({
            code: ec.external_code,
            key_fund: ec.key_fund
          }));
        }
      } catch (error) {
        this.$toast.error(error.name, error.message)
      } finally {
        this.isLoading = false
      }
    }
  },
  computed: {
    allowExternalCodesFromSystemMappings() {
      return this.$store.getters['configVarsStore/getAllowExternalCodesFromSM'];
    },
    allowEditSubdistributor() {
      return this.$store.getters['configVarsStore/getAllowEditSubdistributor'];
    },

    externalCodesWithoutFund() {
      const externalCodes = this.externalCodesTable.items || [];
      return externalCodes.filter(i => i && !i.key_fund);
    },
  },
  /**
   * @override
   */
  beforeMount() {

    const storedComponentData = this.getStoredComponentData();
    this.loadAccount();
    this.detailsEdit = storedComponentData ? storedComponentData.detailsEdit : false;
    if (this.detailsEdit && storedComponentData && Object.keys(storedComponentData).length) {
      Object.entries(storedComponentData).forEach(([key, value]) => (this[key] = value));
    } else {
      this.formatData();
    }
    if (this.$route.name !== 'accounts_add' && !this.creation) {
      this.getDistributors();
      if (this.allowEditSubdistributor) this.getSubdistributors();
    } else {
      this.detailsEdit = true;
    }
  }
};
